import { render, staticRenderFns } from "./linkingTable.vue?vue&type=template&id=34263528&"
import script from "./linkingTable.vue?vue&type=script&lang=js&"
export * from "./linkingTable.vue?vue&type=script&lang=js&"
import style0 from "./linkingTable.vue?vue&type=style&index=0&id=34263528&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports